import styled from 'styled-components';

export const PdfWrapper = styled.div`
    flex: 1;
    min-width: 0;
    height: 80vh;
    display: flex;
    flex-direction: column;
    ${({ isPopup }) => isPopup && 'margin-top: 34px;'}
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
`;

export const PageLabel = styled.p`
    margin-top: 20px;
    color: ${({ color }) => color};
`;

export const PdfDisplayWrapper = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: hidden;
    border: 2px solid #000000;
    :focus-visible {
        border-color: #00806C;
        outline: 4px solid #00806C;
    }
    iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }
`;